import { render, staticRenderFns } from "./DidntReturnVisitsSubHeader.vue?vue&type=template&id=9221ee78&scoped=true"
import script from "./DidntReturnVisitsSubHeader.vue?vue&type=script&lang=js"
export * from "./DidntReturnVisitsSubHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9221ee78",
  null
  
)

export default component.exports